<template>
  <div
    v-if="!loading"
    style="max-width: 600px"
  >
    <v-text-field
      v-model.number="$productGroup.item.cross_sell_title"
      outlined
      hide-details
      dense
      label="Названия кросс-сейл секции"
    />
    <v-row
      class="mt-4"
      no-gutters
    >
      <v-text-field
        v-model.number="$productGroup.item.cross_sell_priority"
        type="number"
        outlined
        hide-details
        dense
        label="Категория кросс-сейла"
        style="max-width: 300px"
      />
      <v-btn
        v-if="crossSellItems.length <= 8 || loading === false"
        color="primary"
        class="ml-4"
        @click="create"
      >
        Добавить продукт
      </v-btn>
    </v-row>

    <div class="mt-4">
      <v-list class="no-scrollbar">
        <v-list-item
          class="pa-0 ma-0"
          v-for="(item, index) in items"
          :key="item.id"
          @click="handleSelect(item)"
        >
          <v-list-item-content class="pa-0 ma-0">
            <v-list-item-title class="mb-4 text-body-2">
              <div class="d-flex justify-space-between align-center">
                <!-- Левая часть -->
                <div class="d-flex align-center">
                  <span class="text-h6 font-weight-bold mr-2">{{ index + 1 }}</span>
                  <span class="text-body-1">{{ item.product.name }}</span>
                  <!-- <span class="text-body-1">{{ ` - приоритет: ${item.priority}` }}</span> -->
                </div>

                <!-- Правая часть -->
                <!-- <div class="text-h6 font-weight-bold">{{ `приоритет: ${item.priority}` }}</div> -->
              </div>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </div>
    <v-dialog
      v-model="dialog"
      max-width="450"
      persistent
    >
      <CrossSellDialogItem
        :key="selectedCrossSell?.id || 'new'"
        :item="selectedCrossSell"
        :selectedProducts="selectedProducts"
        @close="dialog = false"
        @update="update"
        @remove="remove"
        @added="added"
      />
    </v-dialog>
  </div>
  <div
    v-else
    align="center"
  >
    <v-progress-circular
      size="40"
      width="2"
      color="primary"
      indeterminate
    />
  </div>
</template>

<script>
  import CrossSellDialogItem from './CrossSellDialogItem.vue'
  import { CrossSell } from '@/models/crossseil.js'

  export default {
    name: 'ProductGroupCrossSellItem',
    components: { CrossSellDialogItem },
    props: {},
    data: () => ({
      crossSellPriority: null,
      selectedCrossSell: null,
      dialog: false,
      crossSellItems: [],
      crossSellModel: new CrossSell(),
      loading: true
    }),
    computed: {
      items() {
        return this.crossSellItems.sort((a, b) => a.priority - b.priority)
      },
      selectedProducts() {
        return this.crossSellItems.map(e => e.product.id)
      }
    },
    methods: {
      remove(value) {
        const index = this.crossSellItems.findIndex(v => v.id === value.id)
        if (index > -1) {
          this.crossSellItems.splice(index, 1)
        }
      },
      create() {
        this.selectedCrossSell = null
        this.dialog = true
      },
      update(value) {
        const index = this.crossSellItems.findIndex(item => item.id === value.id)
        if (index !== -1) {
          this.$set(this.crossSellItems, index, value)
        }
      },
      added(value) {
        this.crossSellItems.push(value)
      },
      handleSelect(value) {
        console.log(value.id)
        this.selectedCrossSell = value
        this.dialog = true
      }
    },
    mounted() {
      this.crossSellModel
        .loadList({ group: this.$productGroup.item.id })
        .then(val => {
          this.crossSellItems = val
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
</script>

<style scoped>
  .no-scrollbar {
    scrollbar-width: none;
    -ms-overflow-style: none;
  }

  .no-scrollbar::-webkit-scrollbar {
    display: none;
  }
</style>
